export const removeReference = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}